import { useV2ListQuestionsForQuestionnaireQuery } from "@generated";
import type { Question, ValueType } from "../types";

export const useQuestionsList = (questionnaireId: string) => {
  const { data, isLoading, isFetching, refetch } =
    useV2ListQuestionsForQuestionnaireQuery(
      {
        questionnaireId: Number(questionnaireId),
        filter: { active: true },
        include: ["questionnaire-section"],
        page: { size: 500 },
      },
      { refetchOnMountOrArgChange: true }
    );

  const rows: Question[] = (data?.data ?? []).map((q: any) => {
    const attrs = q.attributes ?? {};
    const sectionId = q.relationships?.["questionnaire-section"]?.data?.id;
    return {
      id: String(q.id),
      question: attrs.question ?? "",
      name: attrs.name ?? "",
      slug: attrs.slug ?? "",
      valueType: (attrs["value-type"] ?? "text") as ValueType,
      required: !!attrs.required,
      settings: {
        min: attrs.settings?.min ?? "",
        max: attrs.settings?.max ?? "",
        step: attrs.settings?.step ?? "",
      },
      selectOptions: (attrs["select-options"] ?? []).map((o: any) => ({
        key: o.key ?? "",
        value: o.value ?? "",
        default: !!o.default,
      })),
      sectionId: sectionId != null ? String(sectionId) : "",
      position: attrs.position ?? 0,
    };
  });

  return { rows, isLoading, isFetching, refetch };
};

export default useQuestionsList;
